import clsx from "clsx";
import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { DropdownTemplate, MultiselectTemplate } from "@ryde/controls";
import { LinkStationFormFieldsEnum, onActivateKeyDown } from "@ryde/shared";

import { usePassengerMapLinkStationPanel } from "../../hooks";
import { PassengersLinkStationsPanelStyled } from "./passengers.map.styled";

interface IPassengersMapLinkStationsPanelProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const PassengersMapLinkStationsPanel: FC<
  IPassengersMapLinkStationsPanelProps
> = ({ isOpen, handleClose }) => {
  const {
    methods,
    isDisabled,
    handleClick,
    homeAddressList,
    pickupStationList,
  } = usePassengerMapLinkStationPanel();

  const { setValue } = methods;
  const { t } = useTranslation();

  return (
    isOpen && (
      <FormProvider {...methods}>
        <PassengersLinkStationsPanelStyled>
          <div className="dropdownsContainer">
            <div className="dropdownInput">
              <DropdownTemplate
                name={LinkStationFormFieldsEnum.pickupStation}
                labelTranslated={t("station.stationAddress")}
                formAttributes={{
                  selectItems: pickupStationList,
                }}
              />
            </div>
            <div className="dropdownInput multiSelect">
              <MultiselectTemplate
                name={LinkStationFormFieldsEnum.homeAddresses}
                labelTranslated={t("station.homeAddresses")}
                formAttributes={{
                  limitTagsNumber: 1,
                  selectItems: homeAddressList,
                }}
              />
            </div>
          </div>

          <div className="actionsButtons">
            <div
              onClick={handleClick}
              onKeyDown={onActivateKeyDown(handleClick)}
              role="button"
              tabIndex={0}
              className={clsx("saveButton", { disabled: isDisabled })}
            >
              {t("station.link")}
            </div>

            <PIC.XSVG className="close-icon-svg" onClick={handleClose} />
          </div>
        </PassengersLinkStationsPanelStyled>
      </FormProvider>
    )
  );
};
